<template>
  <div
    v-if="message?.message || message?.metadata?.transcript"
    class="c-chat__userLastMessage t-caption2 o-flex -alignCenter -gap1">
    <SvgIcon
      v-if="message?.metadata?.file_type && icon"
      tiny
      :type="`chat_` + icon" />
    <span
      class="t-overflowEllipsis t-noWrap c-chat__userLastMessageText">{{ isMe ? $t('chat.you') + ": " : '' }} {{text}}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import constants from '@/constants'
import api from '@/logic/api'
import store from '@/store'

const props = defineProps({
  message: {
    type: Object,
    default: null,
  },
})

const icon = computed(() => {
  if (!props.message?.metadata?.file_type) {
    return null
  }
  if (+props.message.metadata.file_type === constants.LEARNINGMATERIALS.TYPE_DOCUMENT_IMAGE) {
    return 'photo'
  }
  return 'attachment'
})

const text = computed(() => {
  if (!props.message?.metadata?.file_type || props.message?.metadata?.transcript) {
    const rawText = props.message?.metadata?.transcript ?? props.message?.message
    if (rawText) {
      return rawText.trim().replace(/<br\/>?/g, ' ').replace(/<[^>]*>/g, '')
    }
    return ''
  }
  if (+props.message.metadata.file_type === constants.LEARNINGMATERIALS.TYPE_DOCUMENT_IMAGE) {
    return api.i18n.t('chat.image')
  }
  return api.i18n.t('chat.attachment')
})

const isMe = computed(() => {
  return parseInt(props.message?.azure_sender_id) === store.getters['auth/userId']
})
</script>
